import React, { useEffect, useState } from 'react'
import SockJS from "sockjs-client";
import { Client } from '@stomp/stompjs';
import Lib from "../../../commons/lib";
import { useParams } from 'react-router-dom';
import Services from './Services';
import SvgViewer from '../../../commons/SvgViewer';
import Page404 from '../../Pages/Page404';
import TimeFormatter from '../../../commons/TimeFormatter';

let sockjs = null;

const KulsokliensContent = (props) => {

    // this.state = {
    //   fp: '-',
    //   clientType: 'REKLAM',
    //   layout: {
    //     vna: null,
    //     hna: null,
    //   },
    //   event: {
    //     nam: null
    //   },
    //   init: {
    //     sectors: null
    //   },
    //   sessionId: null,
    //   connected: false,
    //   error: false
    // };


  const [ fp, setFp ] = useState('-');
  const [ clientType, setClientType ] = useState('REKLAM');
  const [ layout, setLayout ] = useState({
    vna: null,
    hna: null
  });
  const [ event, setEvent ] = useState({ nam: null });
  const [ init, setInit ] = useState({ sectors: null });
  const [ sessionId, setSessionId ] = useState(null);
  const [ connected, setConnected ] = useState(false);
  const [ error, setError ] = useState(false);
  // const { useParams } = props.globals.
  const { eszkozazonosito } = useParams();

  useEffect(() => {
    window.addEventListener("beforeunload", (e) => deleteSession(e), false);
    window.addEventListener("popstate", (e) => deleteSession(e), false);
    setCSS();
    renderToken();

    return () => {
      clearInterval(interval);
      removeCSS();
    }
  }, []);

  // componentDidMount() {
  //   window.addEventListener("beforeunload", (e) => this.deleteSession(e), false);
  //   window.addEventListener("popstate", (e) => this.deleteSession(e), false);
  //   this.setCSS();
  //   this.renderToken();
  // }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  //   removeCSS();
  // }

  // A setCSS változtatásait vissza kell vonni a removeCSS-ben
  const setCSS = () => {
    document.body.classList.add('kulsomonitor');
  }

  const removeCSS = () => {
    document.body.classList.remove('kulsomonitor');
  }

  // componentDidUpdate(prevProps) {
  //   // Typical usage (don't forget to compare props):
  //   if (this.props.authenticated !== prevProps.authenticated) {
  //     console.log('UPDATED DIDUPDTA')
  //   }
  // }

  const deleteSession = (e) => {
    if(sockjs) {
      Services.deleteSession(sessionId, (err, res) => {
        if (!err) {
        }
      });
    }
  }

  const msConversion = (millis) => {
    let sec = Math.floor(millis / 1000);
    let hrs = Math.floor(sec / 3600);
    sec -= hrs * 3600;
    let min = Math.floor(sec / 60);
    sec -= min * 60;
    sec = '' + sec;
    sec = ('00' + sec).substring(sec.length);
  
    if (hrs > 0) {
      min = '' + min;
      min = ('00' + min).substring(min.length);
      return min;
    }
    else {
      return min;
    }
  }

  const emptyFormatter = (data) => {
    if(!data || data === '') return '-';
    return data;
  }

  const isSeatSelected = (seatid, seats) => {
    let hasItem = false;

    seats.forEach(seat => {
      if(seat.sid === seatid) hasItem = true;
    });

    return hasItem;
  }

  const refreshToken = (interval) => {
    if(props.globals.keycloak.updateToken) {
      interval = setInterval(() => props.globals.keycloak.updateToken(msConversion(interval)), 1000);
    }
  }

  const renderToken = () => {
   
    Services.getTimeoutMs((err, res) => {
      if (!err) {
        const updateTime = res[0] - 10000;
        refreshToken(updateTime);
        if(!connected) {
            let clientId = Lib.MicroServices.keycloak.clientId;
            let token = Lib.MicroServices.keycloak.token;

            const randomString = (length=10)=>Math.random().toString(20).substr(2, length);
            const sessionId = randomString();

            const client = new Client();
            sockjs = new SockJS(window.location.origin + "/api/helyszin/ws?eszkozazonosito=" + eszkozazonosito + "&wsclientid=" + clientId + "&wstoken=" + token,[], {
              sessionId: () => {
                 return sessionId;
              }});

            client.webSocketFactory = function () {
                return sockjs;
            };
            client.configure({
              onConnect: () => {
                setConnected(true);
                setSessionId(sessionId);
                setError(false);
                client.subscribe('/user/'+sessionId+'/kulsomonitor', message => {
                  switch (JSON.parse(message.body).payload.type) {
                    case 'LEKERDEZES':
                      setClientType(JSON.parse(message.body).payload.type);
                      setLayout(JSON.parse(message.body).payload.layout);
                      setEvent(JSON.parse(message.body).payload.event);
                      setInit(JSON.parse(message.body).payload.init);
                      break;
                    case 'FOGLALAS':
                      let updatedBlocks = JSON.parse(message.body).payload.getbean.layout.blocks.map((block) => {
                        block.seats.forEach((seat) => {
                          if(isSeatSelected(seat.tid, JSON.parse(message.body).payload.rendeles.seattickets)) {
                              seat.new = true; 
                          }
                        })
                        return block;
                      })
                      let updatedLayout = JSON.parse(message.body).payload.getbean.layout;
                      updatedLayout.blocks = updatedBlocks;
                      setClientType(JSON.parse(message.body).payload.type);
                      setLayout(updatedLayout);
                      setEvent(JSON.parse(message.body).payload.getbean.event);
                      setInit(JSON.parse(message.body).payload.getbean.init);
                      break;
                    case 'REKLAM':
                      setClientType(JSON.parse(message.body).payload.type,)
                      break;
                    default:
                      break;
                  }
                });
              },
            });
            client.activate();
         }     
       }
      });
    
    return ''
  }

  const renderReklam = () => {
    return (
        <img
          src={process.env.PUBLIC_URL + '/img/logo_kultik.png'}
          className="center-img"
          alt="logo"
        />
    );
  }

  const renderJegyvasarlas = () => {
    return (
      <div style={{color: 'white', padding: 20, height: '100%'}}>
        <h1 style={{'text-align': 'center'}}>{emptyFormatter(layout.vna)}</h1>
        <h2 style={{'text-align': 'center'}}>{emptyFormatter(event.nam) + ' | ' +  (event.sta ? TimeFormatter.formatLLLL(event.sta) : '-') + ' | ' + emptyFormatter(layout.hna)}</h2>
        <SvgViewer
          // onKeyDown={this.onKeyDown}
          // onKeyUp={this.onKeyUp}
          // id="svg-monitor"
          fromAdmin
          twoColorMode
          isButtonsActive={false}
          height="600px"
          data={layout}
          szektorok={init.sectors}
          szinek={{
            coa: init.coa,
            con: init.con,
            cop: init.cop
          }}
          onTicketClick={() => { console.log('-')}}
        />
      </div>
    );
  }

    return (
      <div>
        {!error ? (
        <div className="animated fadeIn" style={{ height: '100%' }}>
            {{
              REKLAM: (renderReklam()),
              FOGLALAS: (renderJegyvasarlas()),
              LEKERDEZES: (renderJegyvasarlas())
            }[clientType]}
        </div>
        ):(
        <Page404/>
        )}
      </div>
    );
}

export default KulsokliensContent; 